function GridHeader() {
  return null;
}

export default GridHeader;